var map = {
	"./lg/logo-aberdeenlive.svg": 6147,
	"./lg/logo-accrington.svg": 2218,
	"./lg/logo-bedfordshirelive.svg": 2807,
	"./lg/logo-belfastlive.svg": 2905,
	"./lg/logo-birminghammail.svg": 460,
	"./lg/logo-birminghampost.svg": 4186,
	"./lg/logo-bristolpost.svg": 5279,
	"./lg/logo-buckinghamshirelive.svg": 821,
	"./lg/logo-burtonmail.svg": 8421,
	"./lg/logo-businessInsider.svg": 9808,
	"./lg/logo-buzz.svg": 2220,
	"./lg/logo-cambridgenews.svg": 9706,
	"./lg/logo-chesterchronicle.svg": 468,
	"./lg/logo-corkbeo.svg": 1951,
	"./lg/logo-corklive.svg": 4415,
	"./lg/logo-cornwalllive.svg": 9109,
	"./lg/logo-coventrytelegraph.png": 6649,
	"./lg/logo-coventrytelegraph.svg": 5281,
	"./lg/logo-curiously.svg": 6717,
	"./lg/logo-dailyrecord.svg": 354,
	"./lg/logo-dailystar.svg": 4385,
	"./lg/logo-derbytelegraph.svg": 1797,
	"./lg/logo-devonlive.svg": 6787,
	"./lg/logo-dorsetlive.svg": 9260,
	"./lg/logo-dublinlive.svg": 3171,
	"./lg/logo-edinburghlive.svg": 4275,
	"./lg/logo-essexlive.svg": 2210,
	"./lg/logo-express.svg": 1534,
	"./lg/logo-footballlondon.svg": 9527,
	"./lg/logo-footballscotland.svg": 7554,
	"./lg/logo-galwaybeo.svg": 769,
	"./lg/logo-gazettelive.svg": 6793,
	"./lg/logo-getreading.svg": 598,
	"./lg/logo-getsurrey.svg": 6259,
	"./lg/logo-getwestlondon.svg": 8705,
	"./lg/logo-glasgowlive.svg": 8203,
	"./lg/logo-gloucestershirelive.svg": 3792,
	"./lg/logo-grimsbytelegraph.svg": 7383,
	"./lg/logo-hampshirelive.svg": 9469,
	"./lg/logo-hertfordshiremercury.svg": 3609,
	"./lg/logo-hertslive.svg": 111,
	"./lg/logo-hulldailymail.svg": 783,
	"./lg/logo-inyourarea.svg": 6122,
	"./lg/logo-irishmirror.svg": 7165,
	"./lg/logo-irishstar.svg": 2028,
	"./lg/logo-kentlive.svg": 8316,
	"./lg/logo-leedslive.svg": 9285,
	"./lg/logo-leicestermercury.svg": 7875,
	"./lg/logo-lincolnshirelive.svg": 5302,
	"./lg/logo-liverpool.svg": 7838,
	"./lg/logo-liverpoolecho.svg": 9599,
	"./lg/logo-men.svg": 918,
	"./lg/logo-mirror.svg": 9385,
	"./lg/logo-nechronicle.svg": 6760,
	"./lg/logo-norfolklive.svg": 3808,
	"./lg/logo-northantslive.svg": 7662,
	"./lg/logo-northwales.svg": 7109,
	"./lg/logo-nottinghampost.svg": 9713,
	"./lg/logo-ok.svg": 1963,
	"./lg/logo-oxfordshirelive.svg": 72,
	"./lg/logo-plymouthherald.svg": 4430,
	"./lg/logo-reach-footer.png": 6946,
	"./lg/logo-reach.svg": 1901,
	"./lg/logo-rsvp.svg": 4219,
	"./lg/logo-scottishdailyexpress.svg": 737,
	"./lg/logo-somersetlive.svg": 986,
	"./lg/logo-staffordshirelive.svg": 9101,
	"./lg/logo-stokesentinel.svg": 6856,
	"./lg/logo-suffolklive.svg": 7544,
	"./lg/logo-sussexlive.svg": 5801,
	"./lg/logo-the-express.svg": 1257,
	"./lg/logo-themirror.svg": 4228,
	"./lg/logo-walesonline.svg": 6888,
	"./lg/logo-wiltshirelive.svg": 4511,
	"./lg/logo-yorkshire-live.svg": 6078,
	"./md/logo-aberdeenlive.svg": 7664,
	"./md/logo-accrington.svg": 9725,
	"./md/logo-bedfordshirelive.svg": 661,
	"./md/logo-belfastlive.svg": 2590,
	"./md/logo-birminghammail.svg": 1109,
	"./md/logo-birminghampost.svg": 1531,
	"./md/logo-bristolpost.svg": 8897,
	"./md/logo-buckinghamshirelive.svg": 7528,
	"./md/logo-burtonmail.svg": 8914,
	"./md/logo-businessInsider.svg": 9974,
	"./md/logo-buzz.svg": 6867,
	"./md/logo-cambridgenews.svg": 8354,
	"./md/logo-chesterchronicle.svg": 3660,
	"./md/logo-corkbeo.svg": 428,
	"./md/logo-corklive.svg": 6827,
	"./md/logo-cornwalllive.svg": 475,
	"./md/logo-coventrytelegraph.png": 5205,
	"./md/logo-coventrytelegraph.svg": 8049,
	"./md/logo-curiously.svg": 6366,
	"./md/logo-dailyrecord.svg": 7657,
	"./md/logo-dailystar.svg": 8045,
	"./md/logo-derbytelegraph.svg": 6465,
	"./md/logo-devonlive.svg": 5097,
	"./md/logo-dorsetlive.svg": 6282,
	"./md/logo-dublinlive.svg": 6175,
	"./md/logo-edinburghlive.svg": 4176,
	"./md/logo-essexlive.svg": 9537,
	"./md/logo-express.svg": 4894,
	"./md/logo-footballlondon.svg": 3139,
	"./md/logo-footballscotland.svg": 9108,
	"./md/logo-galwaybeo.svg": 1206,
	"./md/logo-gazettelive.svg": 757,
	"./md/logo-getreading.svg": 779,
	"./md/logo-getsurrey.svg": 1924,
	"./md/logo-getwestlondon.svg": 706,
	"./md/logo-glasgowlive.svg": 1559,
	"./md/logo-gloucestershirelive.svg": 7175,
	"./md/logo-grimsbytelegraph.svg": 553,
	"./md/logo-hampshirelive.svg": 1118,
	"./md/logo-hertfordshiremercury.svg": 5339,
	"./md/logo-hertslive.svg": 8456,
	"./md/logo-hulldailymail.svg": 5168,
	"./md/logo-inyourarea.svg": 8751,
	"./md/logo-irishmirror.svg": 8634,
	"./md/logo-irishstar.svg": 6724,
	"./md/logo-kentlive.svg": 8349,
	"./md/logo-leedslive.svg": 8105,
	"./md/logo-leicestermercury.svg": 3131,
	"./md/logo-lincolnshirelive.svg": 5112,
	"./md/logo-liverpool.svg": 8855,
	"./md/logo-liverpoolecho.svg": 3405,
	"./md/logo-men.svg": 3767,
	"./md/logo-mirror.svg": 5220,
	"./md/logo-nechronicle.svg": 9997,
	"./md/logo-norfolklive.svg": 8197,
	"./md/logo-northantslive.svg": 2774,
	"./md/logo-northwales.svg": 2286,
	"./md/logo-nottinghampost.svg": 4041,
	"./md/logo-ok.svg": 9697,
	"./md/logo-oxfordshirelive.svg": 9462,
	"./md/logo-plymouthherald.svg": 6320,
	"./md/logo-reach-footer.png": 5309,
	"./md/logo-reach.svg": 7377,
	"./md/logo-rsvp.svg": 1325,
	"./md/logo-scottishdailyexpress.svg": 8775,
	"./md/logo-somersetlive.svg": 6015,
	"./md/logo-staffordshirelive.svg": 5805,
	"./md/logo-stokesentinel.svg": 6265,
	"./md/logo-suffolklive.svg": 7722,
	"./md/logo-sussexlive.svg": 9082,
	"./md/logo-the-express.svg": 8680,
	"./md/logo-themirror.svg": 427,
	"./md/logo-walesonline.svg": 516,
	"./md/logo-wiltshirelive.svg": 6485,
	"./md/logo-yorkshire-live.svg": 8824,
	"./sm/logo-aberdeenlive.svg": 2239,
	"./sm/logo-accrington.svg": 4074,
	"./sm/logo-bedfordshirelive.svg": 5359,
	"./sm/logo-belfastlive.svg": 991,
	"./sm/logo-birminghammail.svg": 7766,
	"./sm/logo-birminghampost.svg": 5675,
	"./sm/logo-bristolpost.svg": 5610,
	"./sm/logo-buckinghamshirelive.svg": 6173,
	"./sm/logo-burtonmail.svg": 3066,
	"./sm/logo-businessInsider.svg": 8154,
	"./sm/logo-buzz.svg": 9867,
	"./sm/logo-cambridgenews.svg": 2017,
	"./sm/logo-chesterchronicle.svg": 5670,
	"./sm/logo-corkbeo.svg": 6235,
	"./sm/logo-corklive.svg": 9727,
	"./sm/logo-cornwalllive.svg": 8275,
	"./sm/logo-coventrytelegraph.png": 4904,
	"./sm/logo-coventrytelegraph.svg": 7103,
	"./sm/logo-curiously.svg": 4097,
	"./sm/logo-dailyrecord.svg": 8754,
	"./sm/logo-dailystar.svg": 4554,
	"./sm/logo-derbytelegraph.svg": 6470,
	"./sm/logo-devonlive.svg": 1697,
	"./sm/logo-dorsetlive.svg": 5754,
	"./sm/logo-dublinlive.svg": 6100,
	"./sm/logo-edinburghlive.svg": 2720,
	"./sm/logo-essexlive.svg": 3383,
	"./sm/logo-express.svg": 2996,
	"./sm/logo-footballlondon.svg": 5533,
	"./sm/logo-footballscotland.svg": 4019,
	"./sm/logo-galwaybeo.svg": 9083,
	"./sm/logo-gazettelive.svg": 9717,
	"./sm/logo-getreading.svg": 3737,
	"./sm/logo-getsurrey.svg": 2894,
	"./sm/logo-getwestlondon.svg": 7184,
	"./sm/logo-glasgowlive.svg": 285,
	"./sm/logo-gloucestershirelive.svg": 9211,
	"./sm/logo-grimsbytelegraph.svg": 9192,
	"./sm/logo-hampshirelive.svg": 2972,
	"./sm/logo-hertfordshiremercury.svg": 9592,
	"./sm/logo-hertslive.svg": 6490,
	"./sm/logo-hulldailymail.svg": 9801,
	"./sm/logo-inyourarea.svg": 352,
	"./sm/logo-irishmirror.svg": 6695,
	"./sm/logo-irishstar.svg": 7163,
	"./sm/logo-kentlive.svg": 3734,
	"./sm/logo-leedslive.svg": 1403,
	"./sm/logo-leicestermercury.svg": 1244,
	"./sm/logo-lincolnshirelive.svg": 1504,
	"./sm/logo-liverpool.svg": 5266,
	"./sm/logo-liverpoolecho.svg": 8528,
	"./sm/logo-men.svg": 7728,
	"./sm/logo-mirror.svg": 2229,
	"./sm/logo-nechronicle.svg": 182,
	"./sm/logo-norfolklive.svg": 7775,
	"./sm/logo-northantslive.svg": 4929,
	"./sm/logo-northwales.svg": 5006,
	"./sm/logo-nottinghampost.svg": 5237,
	"./sm/logo-ok.svg": 8181,
	"./sm/logo-oxfordshirelive.svg": 5317,
	"./sm/logo-plymouthherald.svg": 3474,
	"./sm/logo-reach-footer.png": 140,
	"./sm/logo-reach.svg": 2187,
	"./sm/logo-rsvp.svg": 3944,
	"./sm/logo-scottishdailyexpress.svg": 2750,
	"./sm/logo-somersetlive.svg": 486,
	"./sm/logo-staffordshirelive.svg": 8021,
	"./sm/logo-stokesentinel.svg": 7613,
	"./sm/logo-suffolklive.svg": 6403,
	"./sm/logo-sussexlive.svg": 3827,
	"./sm/logo-the-express.svg": 4623,
	"./sm/logo-themirror.svg": 7677,
	"./sm/logo-walesonline.svg": 9237,
	"./sm/logo-wiltshirelive.svg": 7049,
	"./sm/logo-yorkshire-live.svg": 590
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5002;